var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 217,
    height: 217,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 1,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-1.0714285714285714s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.0714285714285714s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.82214306505568,77.36410188638104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(51.42857142857143)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.8571428571428571,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-0.8928571428571428s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.8928571428571428s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.211767311529,84.12247692636382)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(102.85714285714286)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.7142857142857143,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-0.7142857142857142s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.7142857142857142s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.466089623415336,65.18593086911454)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(154.2857142857143)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.5714285714285714,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-0.5357142857142857s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.5357142857142857s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.46608962341533,34.81406913088547)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(205.71428571428572)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.42857142857142855,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-0.3571428571428571s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.3571428571428571s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.21176731152899,15.877523073636176)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(257.1428571428571)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.2857142857142857,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "-0.17857142857142855s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.17857142857142855s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.82214306505567,22.635898113618953)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(308.5714285714286)"
  }, /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.14285714285714285,
    fill: "#7d3c98",
    r: 7,
    cy: 0,
    cx: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    values: "1.77 1.77;1 1",
    begin: "0s",
    type: "scale",
    attributeName: "transform"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "1;0",
    repeatCount: "indefinite",
    dur: "1.25s",
    keyTimes: "0;1",
    attributeName: "fill-opacity"
  })))), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner2);
export default __webpack_public_path__ + "static/media/spinner2.104e86d81e665733a8778c62c5390433.svg";
export { ForwardRef as ReactComponent };